import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom"; // Import Routes and Route
import Home from "./Pages/Home"; // Import the Home component

import InteriorDesignCommercial from "./Pages/InteriorDesign";
import InteriorDesignSelectionPage from "./Pages/InteriorDesignSelectionPage";
import InteriorDesignResidentialSelection from "./Pages/InteriorDesignResidentialSelection";
import ExternalSelection from "./Pages/ExternalSelection";
import Home2 from "./Pages/Home2";
import HomePageReal from "./Pages/HomePageReal";
import ProjectsPage from "./Pages/ProjectsPage";
import LuxeResidences from "./Pages/Residential/LuxeResidences";
import BeysuMansionsPage from "./Pages/Residential/BeysuMansionsPage";
import ModernResidence from "./Pages/Residential/ModernResidence";
import About from "./Pages/About";
import ContactPage from "./Pages/ContactPage";
import HavenResidancePage from "./Pages/Residential/HavenResidancePage";
import DualElegancePage from "./Pages/Residential/DualElegancePage";
import LightAndSpacePage from "./Pages/Residential/LightAndSpacePage";
import ConceptualPenthousePage from "./Pages/Residential/ConceptualPenthousePage";
import Iehouse from "./Pages/Residential/Iehouse";
import PrivateApartment from "./Pages/Residential/PrivateApartment";
import SinpasResidences from "./Pages/Residential/SinpasResidences";
import MagellanRestaurant from "./Pages/Commercial/MagellanRestaurant";
import RadissonBlue from "./Pages/Commercial/RadissonBlue";
import UnodcCentre from "./Pages/Commercial/UnodcCentre";
import RiyadhEmbassy from "./Pages/Commercial/RiyadhEmbassy";
import DawlanceOffice from "./Pages/Commercial/DawlanceOffice";
import Ummbabtower from "./Pages/Commercial/Ummbabtower";
import SadkoBaku from "./Pages/Commercial/SadkoBaku";
import WoodAterlier from "./Pages/Commercial/WoodAterlier";
import Mariott from "./Pages/Commercial/Mariott";
import RomatemMove from "./Pages/Commercial/RomatemMove";
import AzelLaw from "./Pages/Commercial/AzelLaw";
import WanderChocolate from "./Pages/Commercial/WanderChocolate";
import FarmHouse from "./Pages/Commercial/FarmHouse";
import MinimalistPage from "./Pages/Commercial/MinimalistPage";
import HairClinic from "./Pages/Commercial/HairClinic";
import CoastalContemporary from "./Pages/Exterior/CoastalContemporary";
import ModernHarmony from "./Pages/Exterior/ModernHarmony";
import LocaResidences from "./Pages/Exterior/LocaResidences";
import VillaFacade from "./Pages/Exterior/VillaFacade";
import DynamicUrban from "./Pages/Exterior/DynamicUrban";
import PrivateVilla from "./Pages/Exterior/PrivateVilla";

function App() {
  return (
    <Router>
      <div>
        <Routes> {/* Use Routes instead of Switch */}
          <Route path="/" element={<Home />} /> {/* Home page for / */}
          <Route path="/home" element={<Home />} /> {/* Home page for /home */}
          <Route path="/about" element={<About />} />
          <Route path="/interior-design/commercial" element={<InteriorDesignCommercial />} /> {/* InteriorDesignCommercial page */}
          <Route path="/interior-design/residential" element={<InteriorDesignResidentialSelection />} /> {/* InteriorDesignCommercial page */}
          {/* <Route path="/interior-design" element={<InteriorDesignSelectionPage />} /> InteriorDesignSelectionPage */}
          <Route path="/exterior-design" element={<ExternalSelection />} />
          <Route path ="/Projects" element= {<ProjectsPage/>} />
          <Route path ="/interior-design/residential/luxe-residance" element = {<LuxeResidences/>} />
          <Route path ="/interior-design/residential/beysu-mansions" element = {<BeysuMansionsPage/>} />
          <Route path ="/interior-design/residential/modern-residence" element = {<ModernResidence/>} />
          <Route path ="/interior-design/residential/haven-residence" element = {<HavenResidancePage/>} />
          <Route path ="/interior-design/residential/dual-elegance" element = {<DualElegancePage/>} />
          <Route path ="/interior-design/residential/light-and-space" element = {<LightAndSpacePage/>} />
          <Route path ="/interior-design/residential/conceptual-penthouse" element = {<ConceptualPenthousePage/>} />
          <Route path ="/interior-design/residential/ie-house" element = {<Iehouse/>} />
          <Route path ="/interior-design/residential/private-apartment" element = {<PrivateApartment/>} />
          <Route path ="/interior-design/residential/sinpas-residences" element = {<SinpasResidences/>} />
          <Route path = "/contact" element = {<ContactPage/>} />

          {/* commercial */}
          <Route path ="/interior-design/commercial/magellan-restaurant" element = {<MagellanRestaurant/>} />
          <Route path ="/interior-design/commercial/radisson-blue" element = {<RadissonBlue/>} />
          <Route path ="/interior-design/commercial/unodc-centre" element = {<UnodcCentre/>} />
          <Route path ="/interior-design/commercial/riyadh-turkish" element = {<RiyadhEmbassy/>} />
          <Route path ="/interior-design/commercial/dawlance-office" element = {<DawlanceOffice/>} />
          <Route path ="/interior-design/commercial/ummbab-tower" element = {<Ummbabtower/>} />
          <Route path ="/interior-design/commercial/sadko-baku" element = {<SadkoBaku/>} />
          <Route path ="/interior-design/commercial/wood-atelier" element = {<WoodAterlier/>} />
          <Route path ="/interior-design/commercial/marriott-residence" element = {<Mariott/>} />
          <Route path ="/interior-design/commercial/romatem-move" element = {<RomatemMove/>} />
          <Route path ="/interior-design/commercial/azel-law" element = {<AzelLaw/>} />
          <Route path ="/interior-design/commercial/wander-chocolate" element = {<WanderChocolate/>} />
          <Route path ="/interior-design/commercial/farm-house" element = {<FarmHouse/>} />
          <Route path ="/interior-design/commercial/minimalist-concept" element = {<MinimalistPage/>} />
          <Route path ="/interior-design/commercial/hair-clinic" element = {<HairClinic/>} />

          {/* exterior */}
          <Route path ="/exterior-design/coastal-contemporary" element = {<CoastalContemporary/>} />
          <Route path ="/exterior-design/modern-harmony" element = {<ModernHarmony/>} />
          <Route path ="/exterior-design/loca-residences" element = {<LocaResidences/>} />
          <Route path ="/exterior-design/villa-facade" element = {<VillaFacade/>} />
          <Route path ="/exterior-design/dynamic-urban" element = {<DynamicUrban/>} />
          <Route path ="/exterior-design/private-villa" element = {<PrivateVilla/>} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
